class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    const main = document.querySelector('main') || document.querySelector('#MainContent');
    if (main && this.parentElement !== main) main.appendChild(this);

    this.targetElement = document.querySelector('.buy-button-holder');
    if (!this.targetElement) return;

    this.stickyVariantInput = this.querySelector('input[name="id"]');
    this.stickyBtn = this.querySelector('[type="submit"]');

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '0px' });

    this.observer.observe(this.targetElement);

    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
  }

  onVariantChange({ data: { variant } }) {
    if (!this.stickyVariantInput || !this.stickyBtn) return;

    if (variant) {
      this.stickyVariantInput.value = variant.id;
      this.stickyVariantInput.disabled = false;
      this.stickyBtn.disabled = !variant.available;
      this.stickyBtn.querySelector('span').textContent = variant.available
        ? window.variantStrings.addToCart
        : window.variantStrings.soldOut;
    } else {
      this.stickyVariantInput.disabled = true;
      this.stickyBtn.disabled = true;
      this.stickyBtn.querySelector('span').textContent = window.variantStrings.unavailable;
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.variantChangeUnsubscriber?.();
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
